import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[maxLenExceededValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: MaxLenExceededDirective, multi: true }],
  standalone: false
})
export class MaxLenExceededDirective implements Validator {
  @Input('maxLenExceededValidator') validationMaxLength: number;

  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value && this.validationMaxLength && value.length > this.validationMaxLength) {
      return { 'maxLenExceeded': { requiredLength: this.validationMaxLength, actualLength: value.length } };
    }
    return null;
  }
}